import { BGM_ZPP_COURSE_OFFER_IDS } from '../config/bgmZppCourseOfferIds';

export const getZppCourseOfferId = (bgmCooperation, courseType = 'sda') => {
  return BGM_ZPP_COURSE_OFFER_IDS?.[bgmCooperation]?.[courseType] || null;
};
